import "./AngledButton.css"

export default function AngledButton ({
    title,
    onClick,
    disabled
})  {
    return (
        <button 
            onClick={onClick} 
            className="angled-button"
            disabled={disabled}
        >
            <span>{title}</span>
        </button>

    )
}